import styles from "./Edit.module.css";
import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../Helpers/axiosInstance";
import BaseInformation from "./BaseInformation/BaseInformation";
import { Autocomplete } from "@mui/material";
import InputWithOptions from "../../Components/InputWithOptions";


const EditBase = ({onClose, data , setGroupingBases, unit, unitId}) => {
  const [num, setNum] = useState("");
  const [name, setName] = useState("");
  const [baseInformation, setBaseInformation] = useState(false);
  const [battalions, setBattalions] = useState([])
  const [disabled, setDisabled] = useState(true)
  const [companies, setCompanies] = useState([])
  const [platoons, setPlatoons]= useState([])

  
  const [validity, setValidity] = useState({
    base_company: true,
    base_batallion: true,
    base_platoon: true,
  });
  const [obj, setObj] = useState({
    base_company: "",
    base_cordinates: "",
    base_batallion: "",
    base_platoon: '',
    base_cameraes: false,
    base_responsible: "",
    base_responsible_location: "",
    base_information: [],
  });
  const [array, setArray] = useState([]); 

  useEffect(() => {
    if (data) {
      setNum(data.base_number);
      setName(data.base_name);
      setObj({
        ...obj,
        base_company: data.base_company,
        base_batallion: data.base_batallion,
        base_cordinates: data.base_cordinates,
        base_platoon: data.base_platoon,
        base_cameraes: data.base_cameraes,
        base_responsible: data.base_responsible,
        base_responsible_location: data.base_responsible_location,
      });
      setArray(data.base_information);
      
    }
  }, [data]);

  useEffect(() => {
          (async() => {

              const batalions = await axiosInstance.get(`admin/battalions/${unitId}`)
              const companies = await axiosInstance.get(`admin/companies/${unitId}`)
              const platoons = await axiosInstance.get(`admin/platoons/${unitId}`)
              if(batalions.status){
                  setBattalions(batalions.data.data)
              }
              if(companies.status){
                setCompanies(companies.data.data)
              }
              if(platoons.status){
                setPlatoons(platoons.data.data)
              }
          })()
         }, [unit])


  
  const combinedOptions = {
    base_company: [...companies?.map((el) => el.company_number)],
    base_batallion: [...battalions?.map((el) => el.battalion_number ? el.battalion_number : el.battalion_name)],
    base_platoon: [...platoons?.map((el) => el.platoons_number)],
  }
  
  const handleCheckboxChange = (event) => {
    setObj({
      ...obj,
      base_cameraes: event.target.checked,
    });
  }
  const changeHandler  = (event) => {
    const {name, value} = event.target

    setObj({
        ...obj,
        [name]: value,
    }) 
    if(name === "base_company" || name === "base_batallion" || name === 'base_platoon'){
      const isValid = combinedOptions[name].includes(value);
      setValidity({
        ...validity,
        [name]: isValid,
      });
  }

  }

  
  // const isFormValid = Object.values(validity).every((v) => v);

  const handleAddToDatabase = async () => {
    if(num){
      if (num.trim() === "") {
        alert("Please fill in both fields before adding.");
        return;
      }

      try {

        const base = {
            ...obj,
            base_number: num.trim(),
            base_name: name?.trim(),
            base_unit: unit,
            base_information: array
          }
          
        
        const res = await axiosInstance.post("admin/base", {base: base});
        if(res.status){
          setGroupingBases([...res.data.data])
        }
        setNum("");
        setName("");
        setObj({
          base_company: "",
          base_batallion: "",
          base_platoon: '',
          base_cordinates: "",
          base_cameraes: false,
          base_responsible: "",
          base_responsible_location: "",
          base_information: [], 
        })
        onClose(); 
    
      } catch (error) {
        console.error("Error adding data:", error);
      }
    }
  };


  const handleUpdateDatabase = async () => {
    if (num.trim() === "") {
      alert("Please fill in both fields before updating.");
      return;
    }

    try {
        const base = {
          ...obj,
          new_base_number: num,
          base_name: name,
          base_unit: data.base_unit,
          base_information: array
           
        }
      
        const basik = data.base_number.startsWith("#") ? data.base_number.replace('#','t') : data.base_number
        const res = await axiosInstance.put(`/admin/base/${basik}`, {base: base});
        if(res.data.status){
          setGroupingBases([...res.data.data])
        }
        onClose(); 
    
     
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const getLabelText = () => {
    if (!data) {
      return "Մուտքագրել նոր տվյալներ"
    }else{
      return "Փոփոխել տվյալները"
    }
  };



  return (
    <div className={styles["editing-container"]} onClick={onClose}>
      <div className={styles["modal"]} onClick={(e) => e.stopPropagation()}>
        {/* {!baseInformation ?  */}
        <div>
        <h3>{getLabelText()}</h3>
        {data?.base_number && <h4>Հենակետ {data?.base_number}</h4>}

          <div className={styles["editing-input"]}>
              <div className={`${styles["container"]}`}>
                  <div className={styles['header-h']}>Լրացրեք հենակետի տվյալները</div>
                    <div className={styles["input-view"]}>
                      <label htmlFor="unit_name">Հենակետի Անվանում</label>
                      <input
                        className={styles["input-view"]}
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="unit_number">Հենակետի Համար</label>
                      <input
                        className={styles["input-view"]}
                        type="text"
                        value={num}
                        onChange={(e) => setNum(e.target.value)}
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_company">Վաշտ</label>
                      <Autocomplete
                        options={companies.map((el) => {if(el.company_battalion.battalion_number === obj.base_batallion.split(" ")[0]){return el.company_number}})}
                        value={obj.base_company}
                        onChange={(event, newValue) => {
                            setObj({
                            ...obj,
                            base_company: newValue || ''
                            });
                            setValidity(companies.map((el) => el.company_number).includes(newValue) ? {
                              ...validity,
                              base_company: true,
                            } : {
                              ...validity,
                              base_company: false,
                            });
                        }}
                        renderInput={(params) => (<InputWithOptions
                            inputProps={params.inputProps}
                            InputProps={params.InputProps}
                            inputRef={params.InputRef}
                            label=""
                            mr="40px"
                            validity={true}
                            value={obj.base_company}
                            name="base_company"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setObj({
                                ...obj,
                                [name]: value
                              });
                              setValidity(companies.map((el) => el.company_number).includes(value) ? {
                                ...validity,
                                [name]: true,
                              } : {
                                ...validity,
                                [name]: false,
                              });
                            }}
                          />
                        )}
                        filterOptions={(props, state) => {
                            const filtered = props.filter((option) => option?.toLowerCase().includes(obj.base_company.toLowerCase()));
                            return filtered;
                        }
                      } />
                  </div>
                    <div className={styles["input-view"]}>
                      <label htmlFor="base_platoon">Դասակ</label>
                      <Autocomplete
                        options={platoons.map((el) => {if(el.platoon_battalion.battalion_number === obj.base_batallion.split(" ")[0] && el.platoon_company.company_number === obj.base_company){return el.platoon_number}})}
                        value={obj.base_platoon}
                        onChange={(event, newValue) => {
                            setObj({
                            ...obj,
                            base_platoon: newValue || ''
                            });
                            setValidity(platoons.map((el) => el.platoon_number).includes(newValue) ? {
                              ...validity,
                              base_platoon: true,
                            } : {
                              ...validity,
                              base_platoon: false,
                            });
                        }}
                        renderInput={(params) => (<InputWithOptions
                            inputProps={params.inputProps}
                            InputProps={params.InputProps}
                            inputRef={params.InputRef}
                            label=""
                            mr="40px"
                            validity={true}
                            value={obj.base_platoon || []}
                            name="base_platoon"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setObj({
                                ...obj,
                                [name]: value
                              });
                              setValidity(platoons.map((el) => el.platoon_number).includes(value) ? {
                                ...validity,
                                [name]: true,
                              } : {
                                ...validity,
                                [name]: false,
                              });
                            }}
                          />
                        )}
                        filterOptions={(props, state) => {
                          const filtered = props.filter((option) =>
                              option ? option.toLowerCase().includes((obj.base_platoon || '').toLowerCase()) : ''
                          );
                          return filtered;
                        }
                      } 
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_batallion">Գումարտակ</label>
                      <Autocomplete
                        options={battalions.map((el) => el.battalion_number + " " + el.battalion_name)}
                        value={obj.base_batallion}
                        onChange={(event, newValue) => {
                            setObj({
                            ...obj,
                            base_batallion: newValue || ''
                            });
                            setValidity(battalions.map((el) => el.battalion_number || el.battalion_name).includes(newValue) ? {
                              ...validity,
                              base_batallion: true,
                            } : {
                              ...validity,
                              base_batallion: false,
                            });
                        }}
                        renderInput={(params) => (<InputWithOptions
                            inputProps={params.inputProps}
                            InputProps={params.InputProps}
                            inputRef={params.InputRef}
                            label=""
                            mr="40px"
                            validity={true}
                            value={obj.base_batallion}
                            name="base_batallion"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setObj({
                                ...obj,
                                [name]: value
                              });
                              setValidity(battalions.map((el) => el.battalion_number || el.battalion_name).includes(value) ? {
                                ...validity,
                                [name]: true,
                              } : {
                                ...validity,
                                [name]: false,
                              });
                            }}
                          />
                        )}
                        filterOptions={(props, state) => {
                            const filtered = props.filter((option) => option.toLowerCase().includes(obj.base_batallion.toLowerCase()));
                            return filtered;
                        }
                      } />
                      {/* <input
                        style={{
                          borderColor: obj.base_batallion && !validity.base_batallion ? 'red' : '',
                        }}
                        list="base_batallion"
                        className={styles["input-view"]}
                        type="text"
                        name="base_batallion"
                        value={obj.base_batallion}
                        onChange={changeHandler}
                      />
                      <datalist id="base_batallion" onChange={changeHandler} value={obj.base_batallion}>
                        {battalions.map((el,i) => <option key={i} value={el.battalion_number || el.battalion_name}>{el.battalion_number || el.battalion_name}</option>)}
                      </datalist> */}
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_cordinates">Կորդինատներ</label>
                      <input
                        className={styles["input-view"]}
                        type="text"
                        name="base_cordinates"
                        value={obj.base_cordinates}
                        onChange={changeHandler}
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_responsible">Պատասխանատու</label>
                      <input
                        className={styles["input-view"]}
                        type="text"
                        name="base_responsible"
                        value={obj.base_responsible}
                        onChange={changeHandler}
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_responsible_location">Պատասխանատուի վայրը</label>
                      <input
                        className={styles["input-view"]}
                        type="text"
                        name="base_responsible_location"
                        value={obj.base_responsible_location}
                        onChange={changeHandler}
                      />
                  </div>
                  <div className={styles["input-view"]}>
                      <label htmlFor="base_cameraes">Տեսախցիկների առկայությունը</label>
                      <input
                        className={styles["input-view"]}
                        type="checkbox"
                        name="base_cameraes"
                        checked={obj.base_cameraes}
                        onChange={handleCheckboxChange}
                      />
                  </div>
              </div>
              <div className={styles['base-information']}>
                <BaseInformation
                array={array}
                setArray={setArray}
                unit={unitId}
                submitHandler={() => !data ? handleAddToDatabase() : handleUpdateDatabase()}
                
                />
              </div>
          </div>
       
          <div className={styles["button-group"]}>
            <button className={`${styles["button-view"]} ${styles["add"]}`} onClick={() => !data ? handleAddToDatabase() : handleUpdateDatabase()}>
              Հաստատել
            </button>
            <button className={`${styles["button-view"]} ${styles["close"]}`} onClick={onClose}>
              Չեղարկել
            </button>
          </div>
          </div>
      </div>
      
    </div>
  );
};

export default EditBase;
